import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[uiSnackbarRef]',
  standalone: false,
})
export class SnackbarDirective {
  constructor(public containerRef: ViewContainerRef) {}
}
